import { css, cx } from '@linaria/core';
import { memo, useCallback, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { breakpoints } from 'styles/utils';
import { ModelPricing } from 'components/Pricing/ModelPricing';
import { usePromptSuggestion } from '../hooks/utils/usePromptSuggestion/usePromptSuggestion';
import { PlaygroundConfig } from '../types/playgroundConfig';
import { useCompareMode } from '../hooks/utils/useCompareMode';
type Props = {
  onClickHandler?: (text: string) => void;
  isCompareMode?: boolean;
};
type CardProps = {
  title: string;
  onClickHandler?: (text: string) => void;
};
const Card = ({
  title,
  onClickHandler
}: CardProps) => {
  const {
    boldWords,
    remainingWords
  } = useMemo(() => {
    return {
      boldWords: title?.split(' ')?.slice(0, 3)?.join(' '),
      remainingWords: title?.split(' ')?.slice(3)?.join(' ')
    };
  }, [title]);
  return <button type="button" className={cx(title ? 'card' : ShimmerLoading)} onClick={() => onClickHandler?.(title)}>
      <h3>
        <span className="bold">{boldWords}</span> {remainingWords}
      </h3>
    </button>;
};
const Cards = memo(({
  onClickHandler,
  isCompareMode
}: Pick<Props, 'onClickHandler' | 'isCompareMode'>) => {
  const {
    prompts
  } = usePromptSuggestion();
  const promptsToShow = useMemo(() => {
    return isCompareMode ? prompts?.slice(0, 3) : prompts;
  }, [prompts, isCompareMode]);
  return <ul className="card-list">
      {promptsToShow?.map(prompt => <Card key={prompt.id} title={prompt.title} onClickHandler={onClickHandler} />)}
    </ul>;
});
export const ChatPlaceholder: React.FC<Props> = memo(({
  onClickHandler
}) => {
  const {
    promptSuggestionConfig
  } = useFeatureFlagsLD();
  const {
    values: {
      model
    }
  } = useFormikContext<PlaygroundConfig>();
  const {
    isCompareMode
  } = useCompareMode();
  const handleClick = useCallback((text: string) => {
    onClickHandler?.(text);
  }, [onClickHandler]);
  if (promptSuggestionConfig?.hide) {
    return null;
  }
  return <div className={container}>
      <h2 className="header"> Welcome to the Chat ({model?.name})</h2>
      <p>Think, write, code, plan or learn. Ask anything, from creative ideas to technical help, and get things done.</p>
      {isCompareMode && <ModelPricing border={false} model={((model as unknown) as CF.API.Models.Model)} tableView />}
      <Cards onClickHandler={handleClick} isCompareMode={isCompareMode} />
    </div>;
});
export const container = "odules__Playground__Components__ChatPlaceholder_tsx-container-c18pwjce";
export const ShimmerLoading = "odules__Playground__Components__ChatPlaceholder_tsx-ShimmerLoading-s1swzkk3";

require("./ChatPlaceholder.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ChatPlaceholder.tsx");